export const demoDoctorIds = [31];
